import ConversionFooterFinance from '../footers/ConversionFooterFinance';
import ConversionFooterOnlinePurchase from '../footers/ConversionFooterOnlinePurchase';

export default function getFooter(flowName) {
    switch (flowName) {
        case 'finance':
            return ConversionFooterFinance;
        case 'buy_online': 
            return ConversionFooterOnlinePurchase;
        default:
            return null;
    }
}
